import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {},
});

const Image1 = ({
  className,
  classes,
  src,
  alt,
  ...rest
}) => {
  return (
    <img
      className={classNames(classes.root, className)}
      src={src}
      alt={alt}
      {...rest}
    />
  );
};

Image1.defaultProps = {
  className: '',
};

Image1.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
};

export default withStyles(styles)(Image1);
